export interface ApplicationOption {
  key: string;
  value: string;
  unit: string;
  title: string;
}

/** Which product fields a quantity strategy reads its value and unit from. */
export const applicationOptions: ApplicationOption[] = [
  {
    key: 'ByRatePerArea',
    value: 'ratePerAreaValue',
    unit: 'ratePerAreaUnit',
    title: 'Rate'
  },
  {
    key: 'ByTotalProduct',
    value: 'totalProductValue',
    unit: 'totalProductUnit',
    title: 'Total Product'
  },
  {
    key: 'ByRatePerTank',
    value: 'ratePerTankValue',
    unit: 'ratePerTankUnit',
    title: 'Rate/Tank'
  }
];

/**
 * Looks up the field mapping for a quantity strategy.
 * @param selectedApplicationOption - The strategy key, e.g. "ByRatePerArea"
 * @returns The matching option, or undefined for an unknown key
 */
export const getApplicationType = (
  selectedApplicationOption: string
): ApplicationOption | undefined =>
  applicationOptions.find(option => option.key === selectedApplicationOption);
